var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24.714
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "57eeb0c6-cbd8-4d89-8d16-a406eb6b3f3a",
    d: "m15 22.357-10-10 10-10",
    fill: "none",
    stroke: "#f7fbfc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.333
  }))));
};

export default SvgChevronLeft;